import { EnhancedRouteProps } from 'router/routes/Enhanced/Enhanced.route';
import ShareableLinks from './pages/ShareableLinks';

export default [
  {
    index: true,
    element: ShareableLinks,
  },
] as Array<EnhancedRouteProps>;
